module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/cash-5a49537bb7c94a1f2a8d33f2b6bdf7de.svg";